// socket/socketInstance.js
import io from "socket.io-client";
import packageJson from "../../../package.json";
import { get_id, get_lang } from "../../helper/UserData/userdate";

let socket;

export const getSocket = () => socket;

export const initSocket = () => {
  if (socket) return socket;

  socket = io(global.config.socketServerUrl, {
    secure: true,
    transports: ["websocket"],
    autoConnect: false, // ⬅️ خیلی مهم
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 1000,
    query: {
      dispatcherId: get_id(),
      language: get_lang(),
      apiVersion: "v1",
      apiSource: "web",
      appVersionCode: String(packageJson.version),
      appVersionName: String(packageJson.version),
    },
  });

  return socket;
};
